var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.705 17.9412C17.805 17.9813 17.905 18.0012 18.005 18.0012C18.145 18.0012 18.295 17.9612 18.415 17.8812C18.625 17.7412 18.755 17.5012 18.755 17.2512V0.751249C18.755 0.491249 18.625 0.261249 18.415 0.121249C18.205 -0.0187512 17.935 -0.0387512 17.705 0.0612488L5.705 5.31125C5.435 5.43125 5.255 5.70125 5.255 6.00125V12.0012C5.255 12.3012 5.435 12.5712 5.705 12.6912L17.705 17.9412ZM17.255 16.1012L6.755 11.5112V6.49125L17.255 1.90125V16.1012Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.755005 17.2513C0.755005 17.6613 1.095 18.0013 1.505 18.0013C1.915 18.0013 2.255 17.6613 2.255 17.2513V12.8113L3.785 12.7513C4.185 12.7313 4.505 12.4013 4.505 12.0013V6.00125C4.505 5.59125 4.165 5.25125 3.755 5.25125H1.505C1.095 5.25125 0.755005 5.59125 0.755005 6.00125V17.2513ZM2.255 11.3113V6.75125H3.005V11.2813L2.255 11.3113Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.095 12.0912C11.865 12.0912 11.635 11.9912 11.475 11.8312L9.25501 9.60125C8.41501 8.76125 8.41501 7.39125 9.25501 6.54125C9.66501 6.13125 10.205 5.91125 10.785 5.91125C11.265 5.91125 11.725 6.07125 12.105 6.36125C12.475 6.07125 12.935 5.91125 13.415 5.91125C13.995 5.91125 14.535 6.14125 14.945 6.55125C15.785 7.39125 15.785 8.76125 14.945 9.61125L12.725 11.8412C12.565 12.0012 12.335 12.1012 12.105 12.1012L12.095 12.0912ZM10.785 7.40125C10.615 7.40125 10.445 7.47125 10.325 7.59125C10.065 7.85125 10.065 8.27125 10.325 8.53125L12.105 10.3212L13.885 8.53125C14.145 8.27125 14.145 7.85125 13.885 7.59125C13.635 7.34125 13.205 7.34125 12.955 7.59125L12.635 7.91125C12.345 8.20125 11.865 8.20125 11.575 7.91125L11.255 7.59125C11.125 7.46125 10.965 7.40125 10.785 7.40125Z",
    fill: "currentColor",
    className: "accent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.b7091047b3c70a7f51cb6cd25eb4a70d.svg";
export { ForwardRef as ReactComponent };